(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.IdentificationController = (function(superClass) {
    extend(IdentificationController, superClass);

    function IdentificationController(scope, transitions, state, location, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.location = location;
      this.modal = modal;
      this.saveLocation = bind(this.saveLocation, this);
      this.validateName = bind(this.validateName, this);
      this.validate = bind(this.validate, this);
      this.transitionTo = bind(this.transitionTo, this);
      $('.leaflet-control-buttongrid').hide();
      this.scope.unique_location_name = true;
      this.scope.validateName = this.validateName;
      if (this.location["new"] == null) {
        this.state.go('^');
        return;
      }
      this.scope.repo = this.location;
      this.scope.invalid = this.location.invalid;
      this.scope.saving = false;
      this.scope.validate = this.validate;
      this.scope.transitionTo = this.transitionTo;
      this.scope.saveLocation = this.saveLocation;
      this.scope.editBinDetails = this.editBinDetails;
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if ($transition.to().name !== 'grower.buyerlocation.place') {
            if (_this.location.feature_group != null) {
              App.map.removeLayer(_this.location.feature_group);
            }
            return App.map.removeControl(_this.location.drawControl);
          }
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.transitionStart();
        };
      })(this));
    }

    IdentificationController.prototype.transitionTo = function(state_name) {
      return this.state.go(state_name);
    };

    IdentificationController.prototype.validate = function(property, value) {
      return this.location.validate(property, value);
    };

    IdentificationController.prototype.validateName = function(name) {
      return this.scope.unique_location_name = this.location.nameIsUnique(name);
    };

    IdentificationController.prototype.saveLocation = function() {
      this.scope.saving = true;
      return this.location.save(+this.state.params.fpcResultId).then((function(_this) {
        return function(response) {
          return _this.state.go('grower.fieldprint.step', {
            id: +_this.state.params.fpcResultId,
            step: +_this.state.params.step
          }, {
            reload: 'grower.fieldprint.step'
          });
        };
      })(this));
    };

    return IdentificationController;

  })(Controller);

}).call(this);
